import { PrivaFormGroupValidationItem } from '@priva/components/form-group-validation';

export function getValidationItems(
    id: string,
    data: { id: string; items: PrivaFormGroupValidationItem[] }[],
): PrivaFormGroupValidationItem[] {
    return data.find((field: { id: string }) => field.id === id)?.items ?? [];
}
